import { render, staticRenderFns } from "./BccMailManagerEtAl.vue?vue&type=template&id=3b1c6bbe&scoped=true&"
import script from "./BccMailManagerEtAl.vue?vue&type=script&lang=js&"
export * from "./BccMailManagerEtAl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c6bbe",
  null
  
)

export default component.exports